import React from 'react';
import { Link } from 'react-router-dom';
import { pages } from '../../App'

const Home = () => {
    return (
        <div style={{ textAlign: 'center' }}>
            <h1>Welcome to Leblebi Apps</h1>
            <h2>Pages</h2>
            <ul style={{ listStyleType: 'none', padding: 0 }}>
                {pages.map((page, index) => (
                    <li key={index} style={{ margin: '10px 0' }}>
                        <Link to={page.path}>{page.path}</Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Home;
